import { Controller } from "@hotwired/stimulus";

export class ToggleController extends Controller {
  static targets = ["element", "active", "panel"];

  static values = {
    className: String,
    classActive: String,
    attrName: String,
    attrValue: String,
  };

  connect() {
    if (this.hasPanelTargets) {
      this._syncPanels();
    }
  }

  change() {
    const element = this.elementTarget;

    if (this.hasClassNameValue && this.classNameValue) {
      element.classList.toggle(this.classNameValue);
    }

    if (this.hasAttrNameValue && this.attrValueValue) {
      if (this.hasAttrValueValue && this.attrValueValue) {
        element.toggleAttribute(this.attrNameValue, this.attrValueValue);
      } else {
        element.toggleAttribute(this.attrNameValue);
      }
    }
  }

  changeActive(event) {
    this.activeTargets.forEach((target) => {
      target.classList.remove(this.classActiveValue);
    });

    event.currentTarget.classList.add(this.classActiveValue);

    if (this.hasPanelTargets) {
      this.panelTargets.forEach((panel, index) => {
        panel.hidden = index !== event.params.index;
      });
    }
  }

  _syncPanels() {
    const activeIndex = this.activeTargets.findIndex((target) =>
      target.classList.contains(this.classActiveValue),
    );

    this.panelTargets.forEach((panel, index) => {
      panel.hidden = index !== (activeIndex >= 0 ? activeIndex : 0);
    });
  }

  showConversation() {
    const parent = this.element.closest(".conversations");
    const controller = this.application.getControllerForElementAndIdentifier(
      parent,
      "toggle",
    );

    controller.change();
  }
}
